<template>
  <div class="trips" :state="sendTrips" :key="keyTrips">
    <b-tabs lazy>
      <template v-slot:tabs-end>
        <b-nav-item v-if="allowed" role="presentation" @click.prevent="newTrip"
          ><b
            ><b-spinner v-if="creatingTrip" type="border" small></b-spinner>
            +</b
          ></b-nav-item
        >
      </template>

      <template v-slot:empty>
        <div class="trips__trip--empty text-center text-muted">
          There are no open trips<br />
          Open a new trip using the <b>+</b> button above.
        </div>
      </template>

      <template v-for="trip in numberTrips">
        <b-tab
          :title="'Trip ' + trip"
          v-bind:key="'dyn-tab-' + trip"
          :active="isNewTab"
        >
          <template v-slot:title>
            <span>Trip {{ trip }}</span
            ><button
              v-if="allowed"
              type="button"
              class="close"
              aria-label="Close"
              @click="deleteTrip(trip)"
            >
              <span
                aria-hidden="true"
                class="trips__trip--delete-trip d-flex align-items-center"
                >&times;</span
              >
            </button>
          </template>

          <div
            :key="keyAlertMessage"
            v-if="$route.params.pathName == 'failed'"
            class="trips__failed-alert"
          >
            <template v-if="alertInfo[trip - 1] !== null">
              <b-alert show dismissible variant="danger">
                {{ alertInfo[trip - 1] }}
              </b-alert>
            </template>
          </div>

          <div
            :key="keyAlertMessage"
            v-if="
              $route.params.pathName == 'alerts' ||
                item.message.validation_alert ||
                item.message.not_quote ||
                item.message.description_not_quote != null
            "
            class="trips__failed-alert"
          >
            <template v-if="item.message.validation_alert">
              <b-alert show dismissible variant="info">
                {{ item.haul[trip - 1].message_alert }}
              </b-alert>
            </template>

            <template
              v-else-if="
                item.message.not_quote ||
                  item.message.description_not_quote != null
              "
            >
              <b-alert show dismissible variant="warning">
                {{ item.message.description_not_quote }}
              </b-alert>
            </template>
          </div>

          <div class="autocompletes-container">
            <div class="autocompletes-container__customer">
              <Customer
                @reloadCustomer="reloadCustomer"
                :tripNumber="trip"
                :key="keyCustomer"
              />
            </div>

            <div class="autocompletes-container__mode">
              <b-overlay
                :show="gettingModes"
                rounded
                opacity="0.6"
                spinner-small
              >
                <Mode
                  :tripNumber="trip"
                  :getModes="getModes"
                  :key="keyMode"
                  :actualQueue="actualQueue"
                  @stopSpinner="stopSpinner"
                />
              </b-overlay>
            </div>

            <div
              v-if="actualQueue && actualQueue === 'drayage'"
              class="autocompletes-container__customer"
            >
              <DrayageProvider :tripNumber="trip" />
            </div>
          </div>
          <div class="autocompletes-container">
            <div class="autocompletes-container__requote">
              <b-form-checkbox
                :key="checkKey"
                @input="requoteTrip(trip - 1)"
                :id="'checkbox-requote' + trip"
                v-model="requote[trip - 1]"
                :name="'checkbox-requote' + trip"
                value="accepted"
                unchecked-value="not_accepted"
                class="checkbox-requote"
                :disabled="!allowed"
              >
                Requote
              </b-form-checkbox>
            </div>
            <div class="autocompletes-container__insurance">
              <b-form-checkbox
                :key="checkKey"
                @input="insuranceTrip(trip - 1)"
                :id="'checkbox-insurance' + trip"
                v-model="insurance[trip - 1]"
                :name="'checkbox-insurance' + trip"
                value="accepted"
                unchecked-value="not_accepted"
                class="checkbox-insurance"
                :disabled="!allowed"
              >
                Insurance Required
              </b-form-checkbox>
            </div>

            <div
              class="autocompletes-container__drayage-checkbox"
              v-if="!isLtl"
            >
              <b-form-checkbox
                :key="checkKey"
                @change="changeX1tc(trip - 1)"
                v-model="x1tc[trip - 1]"
                class="checkbox-insurance"
                :disabled="!allowed"
              >
                X1tc
              </b-form-checkbox>
            </div>
          </div>

          <div class="autocompletes-container">
            <div
              class="autocompletes-container__drayage-checkbox"
              v-if="!isLtl"
            >
              <b-form-checkbox
                :key="checkKey"
                @change="changeShipper(trip - 1)"
                v-model="shipper[trip - 1]"
                class="checkbox-insurance"
                :disabled="!allowed"
              >
                Shipper
              </b-form-checkbox>
            </div>
            <div
              class="autocompletes-container__drayage-checkbox"
              v-if="!isLtl"
            >
              <b-form-checkbox
                :key="checkKey"
                @change="changeProjectCargo(trip - 1)"
                v-model="projectCargo[trip - 1]"
                class="checkbox-insurance"
                :disabled="!allowed"
              >
                Project Cargo
              </b-form-checkbox>
            </div>
            <div
              class="autocompletes-container__drayage-checkbox"
              v-if="!isLtl"
            >
              <b-form-checkbox
                :key="checkKey"
                @change="rescueLoadTrip(trip - 1)"
                v-model="rescueLoad[trip - 1]"
                class="checkbox-insurance"
                :disabled="!allowed"
              >
                Rescue Load
              </b-form-checkbox>
            </div>
            <div
              class="autocompletes-container__drayage-checkbox"
              v-if="!isLtl"
            >
              <b-form-checkbox
                :key="checkKey"
                @change="bidQuoteTrip(trip - 1)"
                v-model="bidQuote[trip - 1]"
                class="checkbox-insurance"
                :disabled="!allowed"
              >
                Bid Quote
              </b-form-checkbox>
            </div>
          </div>

          <div class="between-components">
            <pickupAndDelivery
              v-model="trips.pickupAndDelivery[trip - 1]"
              :tripNumber="trip"
              :newTab="numberTrips"
            />
          </div>

          <div
            class="trips__trip--global-accessorials-ltl between-components"
            v-if="
              trips.accessorials &&
                actualQueue != 'drayage' &&
                selectedModeName != 'Drayage'
            "
          >
            <AccessorialsGlobalLTL
              v-model="trips.accessorials[trip - 1]"
              :tripNumber="trip"
            />
          </div>
          <div v-if="accessoriesNotAvailableForMode">
            <b-alert show variant="warning">
              The following accessorials are chosen for the current load and are
              not available for this quotation mode.</b-alert
            >
          </div>

          <div
            v-if="
              !isLtl &&
                (actualQueue == 'drayage' ||
                  selectedModeName == 'Drayage' ||
                  (actualQueue == 'tempcontrol' &&
                    selectedModeName === 'Reefer Drayage'))
            "
            class="trips__trip__xenon between-components"
          >
            <b-button
              v-b-toggle.collapse-xenon-table
              size="sm"
              class="trips__trip__xenon--button"
              ><span
                ><b-icon icon="caret-down"></b-icon> Show Xenon Table
              </span></b-button
            >
            <b-collapse
              class="trips__trip__xenon-collpase"
              visible
              id="collapse-xenon-table"
            >
              <Xenon
                :tripNumber="trip"
                :pickupAndDelivery="trips.pickupAndDelivery"
              />
            </b-collapse>
          </div>

          <div class="trips__trip--items-table between-components">
            <template v-if="!isLtl">
              <ItemsTableFTL
                v-model="trips.items[trip - 1]"
                :tripNumber="trip"
                :pickupAndDelivery="trips.pickupAndDelivery"
                :accessorials="trips.accessorials"
                :detailsTrip="trips.detailsTrip"
                :fullItems="trips.items"
                :actualQueue="actualQueue"
              />
            </template>
            <template v-else>
              <ItemsTableLTL :tripNumber="trip" />
              <div class="aditional-info-trip" style="margin-top: none">
                <p>DENSITY: {{ calculateDensity }}</p>
              </div>
              <div class="aditional-info-trip">
                <div class="aditional-info-trip__density-class">
                  <label :for="'density-class' + trip">NMFC Class:</label>
                  <b-form-select
                    v-model="densityClass[trip - 1]"
                    :options="nmfcClassOptions"
                    @input="setDensityClass(trip - 1)"
                    :disabled="!allowed"
                    size="sm"
                  ></b-form-select>
                </div>
              </div>
            </template>
          </div>

          <div
            v-if="
              !isLtl &&
                actualQueue != 'drayage' &&
                selectedModeName != 'Drayage'
            "
            class="between-components"
          >
            <div class="row m-1">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <!-- Llamado al componente que emite el value -->
                <DetailsTrip
                  v-model="trips.detailsTrip[trip - 1]"
                  :tripNumber="trip"
                />
              </div>
            </div>
          </div>

          <div
            v-if="
              !isLtl &&
                actualQueue != 'drayage' &&
                selectedModeName != 'Drayage'
            "
            class="between-components"
          >
            <div class="row m-1">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <CarrierCost
                  :tripNumber="trip"
                  :disableCalculate="disableCalculate"
                />
              </div>
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <SuggestedRate :tripNumber="trip" />
              </div> -->
            </div>

            <div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <SpecialServicesModel :tripNumber="trip" />
              </div>
            </div>
          </div>

          <div v-if="!isLtl" class="trips__trip__map between-components">
            <b-button
              v-if="allowed"
              size="sm"
              class="trips__trip__map--button"
              @click="setShowMap(trip)"
              ><span :key="showMapKey" v-if="showMap[trip - 1] == false"
                ><b-icon icon="caret-down"></b-icon> Show</span
              ><span :key="showMapKey" v-if="showMap[trip - 1] == true"
                ><b-icon icon="caret-up"></b-icon> Hide</span
              >
              map</b-button
            >
          </div>
          <div v-if="!isLtl" class="between-components">
            <transition name="fade">
              <Map
                :key="showMapKey"
                v-if="showMap[trip - 1] == true"
                :tripNumber="trip"
                v-model="thereIsMap"
                :pickupAndDelivery="trips.pickupAndDelivery"
              />
            </transition>
          </div>
        </b-tab>
      </template>
    </b-tabs>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
/******************** OTR components **********************/
import PickupAndDelivery from "./PickupAndDelivery";
import ItemsTableFTL from "../OTR/ItemsTableFTL";
// import AccessorialsFTL from "../OTR/AccessorialsFTL";
import DetailsTrip from "../OTR/DetailsTrip";
import CarrierCost from "../OTR/CarrierCost";
import SpecialServicesModel from "../OTR/SpecialServicesModel.vue";
// import SuggestedRate from "../OTR/SuggestedRate";
import Map from "../OTR/Map";
import Xenon from "../OTR/Xenon";
import { warningMessageWithoutConfimation } from "@/api/errorMessages";

/******************** LTL components **********************/
import ItemsTableLTL from "../LTL/ItemsTableLTL";
import AccessorialsGlobalLTL from "../LTL/AccessorialsGlobal";

import Customer from "./Customer";
import Mode from "../LTL/Mode";
import DrayageProvider from "./DrayageProvider";

export default {
  name: "Trips",
  components: {
    PickupAndDelivery,
    ItemsTableFTL,
    ItemsTableLTL,
    // AccessorialsFTL,
    AccessorialsGlobalLTL,
    DetailsTrip,
    CarrierCost,
    // SuggestedRate,
    Map,
    Customer,
    Mode,
    Xenon,
    SpecialServicesModel,
    DrayageProvider
  },
  data() {
    return {
      trips: {
        pickupAndDelivery: [],
        accessorials: [],
        detailsTrip: [],
        items: []
      },
      item: null,
      getModes: null,
      showMap: [],
      numberTrips: null,
      tripAux: null,
      showMapKey: 0,
      thereIsMap: false,
      allowed: true,
      user: null,
      isLtl: false,
      keyTrips: 0,
      keyCustomer: 0,
      creatingTrip: 0,
      isNewTab: false,
      alertInfo: [],
      keyAlertMessage: 0,
      keyMode: 0,
      gettingModes: true,
      requote: [],
      insurance: [],
      densityClass: [],
      nmfcClassOptions: [
        { value: null, text: "Please select an option" },
        { value: 500, text: "500" },
        { value: 400, text: "400" },
        { value: 300, text: "300" },
        { value: 250, text: "250" },
        { value: 200, text: "200" },
        { value: 175, text: "175" },
        { value: 150, text: "150" },
        { value: 125, text: "125" },
        { value: 110, text: "110" },
        { value: 100, text: "100" },
        { value: 92.5, text: "92.5" },
        { value: 85, text: "85" },
        { value: 77.5, text: "77.5" },
        { value: 70, text: "70" },
        { value: 65, text: "65" },
        { value: 60, text: "60" },
        { value: 55, text: "55" },
        { value: 50, text: "50" }
      ],
      assignedUser: null,
      disableEmailResponse: true,
      checkKey: 0,
      totalWeight: null,
      totalDensityAndVolume: null,
      calculateDensity: null,
      actualQueue: null,
      selectedModeName: null,
      currentDepartment: null,
      x1tc: {},
      shipper: {},
      projectCargo: {},
      rescueLoad: {},
      bidQuote: {},
      disableCalculate: false,
      accessoriesNotAvailableForMode: false
    };
  },
  watch: {
    keyRefresh() {
      this.getModes = this.$store.dispatch("quotes/quote/getModes", 1);
      if (this.getModes) {
        this.keyMode += 1;
        this.keyCustomer += 1;
      }
    },
    trips: {
      deep: true,
      handler() {
        for (let i in this.trips.items[0]) {
          const hu_count = this.trips.items[0][i].hu_count;
          const dimensions = this.trips.items[0][i].dimensions;
          const weight = this.trips.items[0][i].weight;
          if (hu_count === "" || dimensions === "" || weight === "") {
            this.disableCalculate = true;
            return;
          }
          this.disableCalculate = false;
        }
        // ! Emitir valor del input a la store.
        /* 
          Se conserva el envío a la store dado que carga otros valores importantes para el correcto
          funcionamiento de la aplicación,
         */
        this.$store.commit(
          "carrierCost/setTrailerSelectedInfo",
          this.trips.detailsTrip
        );
      }
    },
    async showTotalDensityAndVolume(value) {
      this.totalDensityAndVolume = value;
      this.getDensity();
    },
    async showTotalWeight(value) {
      this.totalWeight = value;
      this.getDensity();
    },
    async showSelectedMode(value) {
      this.selectedModeName = value;
      if (this.selectedModeName) {
        const responseAccessorials = await this.$store.dispatch(
          "quotes/accessorials/getAccessorials",
          this.selectedModeName
        );
        const responseCanned = await this.getCannedResponses;
        this.compareAccessorials();
        if (responseAccessorials === 400 && responseCanned.length === 0) {
          warningMessageWithoutConfimation(
            "This mode has no available accessorials and canned responses."
          );
        }
      }
    }
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapState({ keyRefresh: state => state.login.keyRefresh }),
    ...mapGetters("totals", ["showTotalDensityAndVolume", "showTotalWeight"]),
    ...mapGetters("quotes/quote", ["showSelectedMode"]),
    ...mapGetters("quotes", ["showActualQueue"]),
    ...mapGetters("cannedResponses", ["getCannedResponses"]),
    sendTrips() {
      return this.$emit("input", this.trips);
    }
  },
  async created() {
    this.item = this.$store.getters["quotes/quote/showQuoteById"];
    if (this.$route.params.pathName === "failed") {
      this.errorMessage();
    }
    this.setModes();
    this.numberTrips = this.item.haul.length;
    this.totalDensityAndVolume = this.showTotalDensityAndVolume;
    this.totalWeight = this.showTotalWeight;
    this.getDensity();
    //
    this.actualQueue = localStorage.getItem("actual-queue");
  },
  beforeMount() {
    for (let i in this.item.haul) {
      if (this.item.haul[i].requoted) {
        this.requote[i] = "accepted";
      } else if (!this.item.haul[i].requoted) {
        this.requote[i] = "not_accepted";
      }
      if (this.item.haul[i].insurance_required) {
        this.insurance[i] = "accepted";
      } else if (!this.item.haul[i].insurance_required) {
        this.insurance[i] = "not_accepted";
      }
      this.densityClass[i] = this.item.haul[i].density_class;
    }
    this.checkboxDrayageValue();
    this.createTrips();
  },
  methods: {
    getDepartmentName() {
      const departmentOptions = {
        drayage: "Drayage",
        ftl: "OTR"
      };
      if (this.showActualQueue) return departmentOptions[this.showActualQueue];
      else return "LTL";
    },
    async setModes() {
      this.getModes = this.$store.dispatch(
        "quotes/quote/getModes",
        this.getDepartmentName()
      );
    },
    async reloadCustomer() {
      let quoteId = this.$route.params.id;
      await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      this.keyCustomer += 1;
    },
    stopSpinner() {
      this.gettingModes = false;
    },
    createTrips() {
      let userAux = localStorage.getItem("charlie-username-otr");
      this.user = JSON.parse(userAux);
      this.currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (this.currentDepartment.department_id == 1 &&
          this.currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      for (let i = 0; i < this.numberTrips; i++) {
        this.showMap[i] = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (
        !allowedRoutes.includes(this.$route.params.pathName) ||
        (this.currentDepartment.rol_name == "quoter" &&
          this.$route.params.pathName == "queue") ||
        this.disableEmailResponse ||
        this.item.message.validation_alert
      ) {
        this.allowed = false;
      }
      if (
        this.$store.getters["login/showUserLoggedIn"][0].department.name ==
        "ltl"
      ) {
        this.isLtl = true;
      }
    },
    setShowMap(trip) {
      this.showMap[trip - 1] = !this.showMap[trip - 1];
      this.showMapKey += 1;
    },
    async deleteTrip(trip) {
      this.creatingTrip = true;
      let haulId = this.$store.getters["quotes/quote/showQuoteById"].haul[
        trip - 1
      ].id;
      let response = await this.$store.dispatch(
        "quotes/haul/deleteHaul",
        haulId
      );
      this.creatingTrip = false;
      if (response.status == 204) {
        let quoteId = this.$route.params.id;
        await this.$store.dispatch("quotes/quote/getQuote", quoteId);
        this.item = await this.$store.getters["quotes/quote/showQuoteById"];
        this.numberTrips = this.item.haul.length;
        this.keyTrips += 1;
        this.createTrips();
      }
    },
    async newTrip() {
      this.isNewTab = true;
      this.creatingTrip = true;
      let info = {};
      let lengthHauls = this.item.haul.length;
      let response;
      if (lengthHauls != 0) {
        let quoteId = this.$route.params.id;
        await this.$store.dispatch("quotes/quote/getQuote", quoteId);
        this.item = await this.$store.getters["quotes/quote/showQuoteById"];
        info = this.item.haul[lengthHauls - 1];
        let accessorials = info.accessorial;
        let commodity = info.commodity;
        delete info.accessorial;
        delete info.commodity;
        delete info.id;
        delete info.shp;
        info.quote_ = this.$route.params.id;
        info.density_class = "";
        response = await this.$store.dispatch("quotes/haul/addHaul", info);
        for (let i in commodity) {
          let newCommodity = commodity[i];
          delete newCommodity.id;
          newCommodity.haul_ = response.data.id;
          await this.$store.dispatch(
            "quotes/commodity/addCommodity",
            newCommodity
          );
        }
        for (let i in accessorials) {
          let newAccessorials = {
            body: {},
            params: null
          };
          newAccessorials.body.haul_ = response.data.id;
          newAccessorials.body.accessorial_ = accessorials[i].accessorial.id;
          newAccessorials.params = this.selectedModeName;
          await this.$store.dispatch(
            "quotes/accessorials/checkAccessorial",
            newAccessorials
          );
        }
      } else {
        info.quote_ = this.$route.params.id;
        response = await this.$store.dispatch("quotes/haul/addHaul", info);
      }
      if (response.status == 201) {
        await this.$store.dispatch("quotes/quote/getQuote", info.quote_);
        this.item = this.$store.getters["quotes/quote/showQuoteById"];
        this.numberTrips = this.item.haul.length;
        this.keyTrips += 1;
        this.checkKey += 1;
        this.creatingTrip = false;
        this.createTrips();
        if (info.insurance_required == true) {
          this.insurance[this.numberTrips - 1] = "accepted";
        } else {
          this.insurance[this.numberTrips - 1] = "not_accepted";
        }
        if (info.requoted == true) {
          this.requote[this.numberTrips - 1] = "accepted";
        } else {
          this.requote[this.numberTrips - 1] = "not_accepted";
        }
      }
      this.keyAlertMessage += 1;
    },
    async requoteTrip(trip) {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let info = {};
      info.haulId = this.item.haul[trip].id;
      info.payload = {};
      if (this.requote[trip] == "accepted") {
        info.payload.requoted = true;
      } else if (this.requote[trip] == "not_accepted") {
        info.payload.requoted = false;
      }
      await this.$store.dispatch("quotes/haul/updateHaul", info);
    },
    async insuranceTrip(trip) {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let info = {};
      info.haulId = this.item.haul[trip].id;
      info.payload = {};
      if (this.insurance[trip] == "accepted") {
        info.payload.insurance_required = true;
      } else if (this.insurance[trip] == "not_accepted") {
        info.payload.insurance_required = false;
      }
      await this.$store.dispatch("quotes/haul/updateHaul", info);
    },
    async setDensityClass(trip) {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let info = {};
      info.haulId = this.item.haul[trip].id;
      info.payload = {};
      if (this.densityClass[trip] != null && this.densityClass[trip] != "") {
        info.payload.density_class = this.densityClass[trip];
        await this.$store.dispatch("quotes/haul/updateHaul", info);
      }
    },
    async errorMessage() {
      for (let i = 0; i < this.item.haul.length; i++) {
        this.alertInfo[i] = null;
        let response = await this.$store.dispatch(
          "quotes/quote/failedMessage",
          this.item.haul[i].id
        );
        if (response.data !== null && response.data !== "") {
          if (response.data[0].haul_id === this.item.haul[i].id) {
            this.alertInfo[i] = response.data[0].description;
          }
        }
      }
      this.keyAlertMessage += 1;
    },
    async getDensity() {
      if (this.totalDensityAndVolume != " cbf" && this.totalDensityAndVolume) {
        this.calculateDensity = this.totalDensityAndVolume.density;
      }
    },
    checkboxDrayageValue() {
      for (let i in this.item.haul) {
        if (this.item.haul[i].x1tc) {
          this.x1tc[i] = this.item.haul[i].x1tc;
        } else {
          this.x1tc[i] = false;
        }
        if (this.item.haul[i].shipper) {
          this.shipper[i] = this.item.haul[i].shipper;
        } else {
          this.shipper[i] = false;
        }
        if (this.item.haul[i].project_cargo) {
          this.projectCargo[i] = this.item.haul[i].project_cargo;
        } else {
          this.projectCargo[i] = false;
        }
      }
    },
    changeX1tc(trip) {
      this.x1tc[trip] = !this.x1tc[trip];
      this.updateCheckbox(trip, "x1tc", this.x1tc[trip]);
    },
    changeShipper(trip) {
      this.shipper[trip] = !this.shipper[trip];
      this.updateCheckbox(trip, "shipper", this.shipper[trip]);
    },
    changeProjectCargo(trip) {
      this.projectCargo[trip] = !this.projectCargo[trip];
      this.updateCheckbox(trip, "project_cargo", this.projectCargo[trip]);
    },
    rescueLoadTrip(trip) {
      this.rescueLoad[trip] = !this.rescueLoad[trip];
      this.updateCheckbox(trip, "rescue_load", this.rescueLoad[trip]);
    },
    bidQuoteTrip(trip) {
      this.bidQuote[trip] = !this.bidQuote[trip];
      this.updateCheckbox(trip, "bid_quote", this.bidQuote[trip]);
    },
    async updateCheckbox(trip, nameCheckbox, valueCheckbox) {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let info = {};
      info.haulId = this.item.haul[trip].id;
      info.payload = {};
      info.payload[nameCheckbox] = valueCheckbox;
      await this.$store.dispatch("quotes/haul/updateHaul", info);
    },
    compareAccessorials() {
      let accessorialsHaul = this.$store.getters["quotes/quote/showQuoteById"]
        .haul[this.numberTrips - 1].accessorial;
      let accessorialsMode = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      let accessorialsHaulId = [];
      let accessorialsModeId = [];
      for (let i in accessorialsHaul) {
        accessorialsHaulId.push(accessorialsHaul[i].accessorial.name);
      }
      for (let i in accessorialsMode) {
        accessorialsModeId.push(accessorialsMode[i].accessorial);
      }
      let differenceAccessorials = accessorialsHaulId.filter(
        element => !accessorialsModeId.includes(element)
      );
      if (differenceAccessorials.length > 0) {
        this.accessoriesNotAvailableForMode = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  @include spinner;
}

.trips {
  margin-top: $margin-most-used;
  &__trip {
    &--delete-trip {
      @include close-button($color-white);
    }

    &__map {
      @include flex-wrap(left);
      &--button {
        @include secondary-button;
      }
      &--img {
        width: 1000px;
        height: auto;
        padding: 8px;
        border-radius: $border-radius;
      }
    }
    &__xenon {
      @include flex-wrap(left);
      margin: 1rem;
      &--button {
        @include secondary-button;
      }
      &--img {
        width: 1000px;
        height: auto;
        padding: 8px;
        border-radius: $border-radius;
      }
    }
    &__xenon-collpase {
      width: 100%;
    }
    &--global-accessorials-ltl {
      margin: 0 15px;
    }
    &--items-table {
      margin: 0px 15px;
    }
  }
  &__response-button {
    margin: 22px 15px;
    @include flex-wrap(left);
    & button {
      @include secondary-button;
    }
  }
  &__sent-email {
    padding: 20px;
    height: 100%;
    font-size: 12px;
    overflow-x: hidden;
    overflow-y: hidden;
    word-wrap: break-word;
  }
}

.aditional-info-trip {
  margin-top: 30px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &__density-class {
    display: flex;
    flex-direction: row;
    align-items: center;
    label {
      white-space: nowrap;
      margin: 0px 10px 0px 0px;
      font-size: 14px;
    }
  }
}

.autocompletes-container {
  display: flex;
  justify-content: space-between;

  &__customer {
    width: 50%;
  }

  &__autocomplete,
  &__mode {
    width: 50%;
  }
  &__autocomplete,
  &__equipment {
    width: 50%;
  }
  &__insurance,
  &__requote,
  &__drayage-checkbox {
    width: 50%;
    margin-top: 20px;
    padding-left: 15px;
    display: flex;
    justify-content: flex-start;
  }
}

.alert-danger {
  margin-top: 20px;
}

.alert-info,
.alert-warning {
  margin: 10px;
}

.between-components {
  margin-top: 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 1400px) {
  .info-email__trip__map--img {
    width: 100% !important;
  }
}

@media (max-width: 1040px) {
  .info-email__trip--items-table {
    margin-top: 30px;
  }
  .autocompletes-container {
    flex-wrap: wrap;
  }

  @media (max-width: 604px) {
    .autocompletes-container {
      display: flex;
      flex-wrap: wrap;

      &__customer {
        width: 100%;
      }

      &__autocomplete,
      &__mode {
        width: 100%;
      }

      &__autocomplete,
      &__equipment {
        width: 100%;
      }

      & .mode {
        padding-left: 17px;
      }
    }
  }
}
</style>
